module.exports = "<div ng-if=\"$ctrl.options\" \r\n     class=\"gridProductStoragesStyle\" \r\n     ui-grid-cellNav\r\n     ui-grid-selection\r\n     ui-grid-edit \r\n     ui-grid-row-edit\r\n     ui-grid=\"$ctrl.options\"></div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/product-storages/product-storages.html
// module id = 80
// module chunks = 0